export default "__VITE_ASSET__ElpUlJRO__"